import * as React from 'react';
import '../css/image-description.sass';
import ProgrammingLockup from './ProgrammingLockup';
import HtmlContent from './HtmlContent';

interface ImageDescriptionProps {
  pkgName: string;
  pkgImgUrl: string;
  showName: string;
  showTiming: string;
  description: string;
  theme?: 'night' | 'day';
}

export default function ImageDescription(props: ImageDescriptionProps) {
  const { theme = 'day' } = props;
  return (
    <>
      <div className={`image-desc ${theme}`}>
        <span className="title">{props.showName}</span>
        <div className="details">
          <ProgrammingLockup
            details={[{ pkgName: props.pkgName, pkgImgUrl: props.pkgImgUrl }]}
            theme={theme}
          />
          <div>
            <div className="timing">{props.showTiming}</div>
            <p className="description">
              <HtmlContent html={props.description} />
            </p>
          </div>
        </div>
      </div>
    </>
  );
}
